// dependencies
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SearchAgainBtn from './../Utils/SearchAgainBtn';
import NotFound from './../Utils/NotFound';
import SomethingWrong from './../Utils/SomethingWrong';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import ReactTooltip from 'react-tooltip';
import {
   AiFillPrinter,
   AiOutlineDoubleRight,
   AiOutlineDoubleLeft,
} from 'react-icons/ai';
import axios from 'axios';
import './GroupResultList.css';

const GroupResultList = () => {
   const [loading, setLoading] = useState(true);
   const { state: formData } = useLocation();
   const [error, setError] = useState('');
   const [result, setResult] = useState([]);

   const { fromRoll, toRoll, semesterg: semester } = formData;

   useEffect(() => {
      try {
         // http://localhost:4000/api/v1/results
         axios
            .post('https://api-bteb.vercel.app/api/v1/results', {
               fromRoll,
               toRoll,
               semester,
            })
            .then((res) => {
               setError('');
               setLoading(false);
               setResult(res.data);
            })
            .catch(() => {
               setResult({});
               setLoading(false);
               setError('There was an API problem!');
            });
      } catch (err) {
         setLoading(false);
         setResult({});
         setError('There was a server problem!');
      }
   }, [fromRoll, semester, toRoll]);

   // status color
   const statusColor = ['#38aa38', '#c02b2b'];

   // loader css
   const loaderStyle = {
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      height: '100vh',
      background: '#15202c',
   };

   return (
      <div
         style={{ padding: '0 10px 10px 10px' }}
         className="common-blue content"
      >
         {result?.data?.length !== 0 && !error && (
            <>
               {loading ? (
                  <ClimbingBoxLoader
                     css={loaderStyle}
                     color="#A3DBDB"
                     loading={loading}
                  />
               ) : (
                  <>
                     <div className="group-result-content">
                        <h1 className="print-heading">
                           {' '}
                           Diploma In Engineering Result{' '}
                        </h1>
                        <h1>
                           {' '}
                           The group results from Roll No. {fromRoll} to Roll
                           No. {toRoll}{' '}
                        </h1>
                        <h2> Total {result.results} results found </h2>
                        <span className="print">
                           <AiOutlineDoubleRight />
                           <button
                              onClick={() => window.print()}
                              data-tip="Click to print the result list"
                              data-for="printToolTip"
                              className="print-btn"
                           >
                              <AiFillPrinter />
                           </button>
                           <AiOutlineDoubleLeft />
                        </span>
                        <ReactTooltip
                           id="printToolTip"
                           type="success"
                           delayHide={1000}
                        />
                     </div>
                     <table className="table">
                        <thead>
                           <th>S.No</th>
                           <th>Roll</th>
                           <th>Semester</th>
                           <th>Result</th>
                           <th>Session</th>
                           <th>Status</th>
                        </thead>
                        <tbody>
                           {result?.data?.map((results, index) => (
                              <tr key={index}>
                                 <td data-label="S.No"> {index + 1} </td>
                                 <td data-label="Roll"> {results.roll} </td>
                                 <td data-label="Semester">
                                    {' '}
                                    {results.semester}{' '}
                                 </td>
                                 <td data-label="Result"> {results.result}</td>
                                 <td data-label="Session">
                                    {' '}
                                    {results.session}{' '}
                                 </td>
                                 <td
                                    style={{
                                       color:
                                          results.status === 'PASSED'
                                             ? statusColor[0]
                                             : statusColor[1],
                                    }}
                                    data-label="Status"
                                 >
                                    {' '}
                                    {results.status}{' '}
                                 </td>
                              </tr>
                           ))}
                        </tbody>
                     </table>{' '}
                  </>
               )}
            </>
         )}

         {result?.data?.length === 0 && <NotFound />}

         {error && <SomethingWrong />}

         {!loading && (
            <span style={{ marginBottom: '30px' }}>
               {' '}
               <SearchAgainBtn />{' '}
            </span>
         )}

         <span
            style={{ color: '#15202c', textAlign: 'center' }}
            className="print-footer"
         >
            Created by Mehedi Islam Ripon <br /> Contact:
            mehediislamripon@gmail.com
         </span>
      </div>
   );
};

export default GroupResultList;
